var map = {
	"./default.png": 82,
	"./s-blocks.png": 83,
	"./s-editor-media.png": 84,
	"./s-editor.png": 85,
	"./s-figures.png": 86,
	"./s-hero.png": 87,
	"./s-links.png": 88,
	"./s-list.png": 89,
	"./s-media.png": 90,
	"./s-news.png": 91,
	"./s-offices.png": 92,
	"./s-page-header.png": 93,
	"./s-reusable-sections.png": 94,
	"./s-teaser.png": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;